const version = '1.2.11'

export default version
